import React from 'react';

class TableBody extends React.PureComponent {
  static defaultProps = {
    onlyBottomBorder: true
  };

  render() {
    const { children, extraCls, onlyBottomBorder } = this.props;
    let cls = 'only-bottom-border';
    if (!onlyBottomBorder) {
      cls = '';
    }
    if (extraCls) {
      cls += ' ' + extraCls;
    }
    return <tbody className={cls}>{children}</tbody>;
  }
}

export default TableBody;
